import { render, staticRenderFns } from "./UserFavoritesView.vue?vue&type=template&id=4adc9775"
import script from "./UserFavoritesView.vue?vue&type=script&lang=js"
export * from "./UserFavoritesView.vue?vue&type=script&lang=js"
import style0 from "./UserFavoritesView.vue?vue&type=style&index=0&id=4adc9775&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports